"use client";

import {
  BUNNY_PLAYBACK_URL_PREFIX,
  GOOGLE_DRIVE_PLAYBACK_URL_PREFIX,
  MUX_PLAYBACK_URL_PREFIX,
  WISTIA_PLAYBACK_URL_PREFIX,
} from "@/config/constants";
import { cn } from "@/utils/helpers";
import dynamic from "next/dynamic";
import LoadingFallback from "../layout/loading-fallback";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false, loading: () => <LoadingFallback /> });
const WistiaPlayer = dynamic(() => import("react-player/wistia"), { ssr: false, loading: () => <LoadingFallback /> });
const NextVideoPlayer = dynamic(() => import("next-video/player"), { ssr: false, loading: () => <LoadingFallback /> });

type VideoPlayerProps = {
  videoUrl: string;
  autoPlay?: boolean;
  muted?: boolean;
  showControls?: boolean;
  loop?: boolean;
  width?: string;
  height?: string;
  iframeFlagType?: "boolean" | "binary";
  handlePlayAction?: () => void;
  handlePauseAction?: () => void;
  handleEndAction?: () => void;
  className?: string;
};

export default function VideoPlayer({
  videoUrl,
  autoPlay = false,
  muted = false,
  showControls = true,
  loop = false,
  width = "100%",
  height = "100%",
  handlePlayAction,
  handlePauseAction,
  handleEndAction,
  className,
}: VideoPlayerProps) {
  if (videoUrl.startsWith(BUNNY_PLAYBACK_URL_PREFIX) || videoUrl.startsWith(MUX_PLAYBACK_URL_PREFIX)) {
    return (
      <NextVideoPlayer
        src={videoUrl}
        autoPlay={autoPlay}
        muted={muted}
        controls={showControls}
        loop={loop}
        onPlay={handlePlayAction ? () => handlePlayAction() : undefined}
        onPause={handlePauseAction ? () => handlePauseAction() : undefined}
        onEnded={handleEndAction ? () => handleEndAction() : undefined}
        style={{
          height: "100%",
          width: "100%",
          "--media-accent-color": "#a95cee",
        }}
        className={cn("aspect-video", className)}
      />
    );
  }

  if (videoUrl.startsWith(GOOGLE_DRIVE_PLAYBACK_URL_PREFIX)) {
    const googleDrivePlaybackUrl = videoUrl.replace("/view?usp=sharing", "/preview");

    return (
      <iframe
        src={googleDrivePlaybackUrl}
        allow="autoplay"
        allowFullScreen
        width={width}
        height={height}
        onPlaying={handlePlayAction ? () => handlePlayAction() : undefined}
        onPause={handlePauseAction ? () => handlePauseAction() : undefined}
        onEnded={handleEndAction ? () => handleEndAction() : undefined}
        className={className}
      />
    );
  }

  if (videoUrl.startsWith(WISTIA_PLAYBACK_URL_PREFIX)) {
    return (
      <WistiaPlayer
        url={videoUrl}
        playing={autoPlay}
        muted={muted}
        controls={showControls}
        loop={loop}
        width={width}
        height={height}
        onPlay={handlePlayAction ? () => handlePlayAction() : undefined}
        onPause={handlePauseAction ? () => handlePauseAction() : undefined}
        onEnded={handleEndAction ? () => handleEndAction() : undefined}
      />
    );
  }

  return (
    <ReactPlayer
      url={videoUrl}
      playing={autoPlay}
      muted={muted}
      controls={showControls}
      loop={loop}
      width={width}
      height={height}
      // config={{ youtube: { playerVars: { showInfo: 0, modestbranding: 1, rel: 0, disablekb: 1 } } }}
      onPlay={handlePlayAction ? () => handlePlayAction() : undefined}
      onPause={handlePauseAction ? () => handlePauseAction() : undefined}
      onEnded={handleEndAction ? () => handleEndAction() : undefined}
    />
  );
}

// Recycled

// 08 May 2025

{
  /* <ReactPlayer
  url={videoUrl}
  playing={autoPlay}
  muted={muted}
  controls={showControls}
  loop={loop}
  width={width}
  height={height}
  // config={{ youtube: { playerVars: { showInfo: 0, modestbranding: 1, rel: 0, disablekb: 1 } } }}
  onPlay={trackPlaybackEvents && handlePlayAction ? () => handlePlayAction() : undefined}
  onPause={trackPlaybackEvents && handlePauseAction ? () => handlePauseAction() : undefined}
  onEnded={trackPlaybackEvents && handleEndAction ? () => handleEndAction() : undefined}
/> */
}

{
  /* <MuxPlayer
  playbackId={muxPlaybackId}
  metadata={{ viewer_user_id: userId }}
  autoPlay={autoPlay}
  muted={muted}
  accentColor="#9333ea"
  onPlaying={trackPlaybackEvents && handlePlayAction ? () => handlePlayAction() : undefined}
  onPause={trackPlaybackEvents && handlePauseAction ? () => handlePauseAction() : undefined}
  onEnded={trackPlaybackEvents && handleEndAction ? () => handleEndAction() : undefined}
  className={cn("h-full w-full object-cover", className)}
/> */
}
